export default __webpack_public_path__ + "static/media/mui.741a52f5.svg";